// THE YEAR (Matt, 2026-09-27: "one year equals one session. Obviously that
// means 12 rounds, one per month"). A round is a month; twelve make a year;
// a year is one sitting at the table. Pure: everything here is arithmetic
// on the round number, so nothing about a save has to change for the
// calendar to exist.
//
// January to December. Three fixed months: January (the year card),
// September (the Harvest) and December (Midwinter, which closes the year
// and the sitting).
export const MONTHS_PER_YEAR = 12;
export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const SEASONS = ['spring', 'summer', 'autumn', 'winter'];
export const SEASON_LABEL = { spring: 'Spring', summer: 'Summer', autumn: 'Autumn', winter: 'Winter' };

// Which month of the year (1-12) and which year (from 1) a round falls in.
export const monthOf = (round) => ((Math.max(1, round) - 1) % MONTHS_PER_YEAR) + 1;
export const yearOf = (round) => Math.floor((Math.max(1, round) - 1) / MONTHS_PER_YEAR) + 1;
export const monthName = (round) => MONTHS[monthOf(round) - 1];
// Dec-Feb winter, Mar-May spring, Jun-Aug summer, Sep-Nov autumn.
const WHEEL = ['winter', 'spring', 'summer', 'autumn'];
export const seasonOf = (round) => WHEEL[Math.floor((monthOf(round) % 12) / 3)];
export const seasonName = (round) => SEASON_LABEL[seasonOf(round)];

// The fixed months. The year card opens the year (the session's goal), the
// Harvest is September, and Midwinter is December: the feast, the winter
// tale, the chronicle, the end of the sitting.
export const YEAR_CARD_MONTH = 1;
export const HARVEST_MONTH = 9;
export const MIDWINTER_MONTH = 12;
export const isYearCard = (round) => monthOf(round) === YEAR_CARD_MONTH;
export const isHarvest = (round) => monthOf(round) === HARVEST_MONTH;
export const isMidwinter = (round) => monthOf(round) === MIDWINTER_MONTH;
export const isYearEnd = (round) => monthOf(round) === MIDWINTER_MONTH;
// The months the deck deals for: every month but the fixed three, in order.
export const FREE_MONTHS = Array.from({ length: MONTHS_PER_YEAR }, (_, i) => i + 1).filter((m) => ![YEAR_CARD_MONTH, HARVEST_MONTH, MIDWINTER_MONTH].includes(m));
export const seasonOfMonth = (month) => WHEEL[Math.floor((month % 12) / 3)];

/** "Year 2 · June". What every screen prints instead of a round number. */
export const dateOf = (round) => `Year ${yearOf(round)} · ${monthName(round)}`;
/** The first round of a year, and the last. */
export const firstRoundOf = (year) => (year - 1) * MONTHS_PER_YEAR + 1;
export const lastRoundOf = (year) => year * MONTHS_PER_YEAR;
/** The rounds of the year a round is in that have not happened yet (this one included). */
export const monthsLeft = (round) => MONTHS_PER_YEAR - monthOf(round) + 1;
